/* eslint-disable */
export default function mainNav() {
  const navContainer = document.querySelector('.header-navigation:has(.submenu-opener)');

  if (!navContainer) return;
  const submenuOpeners = navContainer.querySelectorAll('.submenu-opener');

  submenuOpeners.forEach((submenuOpener) => {
    let isExpanded = false;
    const dropdown = submenuOpener.nextElementSibling;
    const dropdownFocusableItems = dropdown.querySelectorAll('a, button, input, select, textarea');
    const lastFocusableElement = dropdownFocusableItems[dropdownFocusableItems.length - 1];

    submenuOpener.addEventListener('click', () => {
      isExpanded = !isExpanded;
      submenuOpener.setAttribute('aria-expanded', `${isExpanded}`);

      if (isExpanded) {
        dropdownFocusableItems[0].focus()
      }
    });

    dropdown.addEventListener('keydown', (e) => {
      if (isExpanded) {
        switch (e.key) {
          case 'Escape':
            e.stopPropagation();
            isExpanded = !isExpanded;
            submenuOpener.setAttribute('aria-expanded', `${isExpanded}`);
            break;

          case 'Tab':
            if (e.shiftKey) {
              if (document.activeElement === dropdownFocusableItems[0]) {
                isExpanded = false;
                submenuOpener.setAttribute('aria-expanded', `${isExpanded}`);
              }
            } else {
              if (document.activeElement === lastFocusableElement) {
                isExpanded = false;
                submenuOpener.setAttribute('aria-expanded', `${isExpanded}`);
              }
            }
            break;
        }
      }
    });

    document.body.addEventListener('menu-closed', () => {
      if (isExpanded) {
        isExpanded = !isExpanded;
        submenuOpener.setAttribute('aria-expanded', `${isExpanded}`);
      }
    });
  });
}
